// extracted by mini-css-extract-plugin
export default {"form-group":"JameoLogo_form-group__4uXlt","small":"JameoLogo_small__x4alh","medium":"JameoLogo_medium__yoFCw","large":"JameoLogo_large__TamgW","logo":"JameoLogo_logo__WG3z1"};